import { toast } from "saphir";

import { AuthenticationRequiredError, isAccessRedirectError } from "@lib/access/access";
import { redirectForAuthenticationRequired } from "@lib/access/authRedirect";
import { i18n, i18nDK } from "@lib/i18n";
import { router } from "@routes";

import { clearLogas } from "./clearLogas";

// eslint-disable-next-line arrow-body-style
export const handleErrorAsString = (err) => {
    const error = typeof err === "string" ? { key: err } : err;
    if (!error || !error.key) {
        return i18n.errors_generic();
    }

    const key = error.key.replace(/[.-]/g, "_");
    if (typeof err === "string" && !(key in i18n)) {
        return i18n.errors_generic();
    }

    return i18nDK(key, {
        ...(error.metadata ? error.metadata : {}),
    });
};

export const handleError = (err, statusCode = 500, { publicAuth = false } = {}) => {
    // Preserve expected access failures for the global query/mutation handler.
    if (isAccessRedirectError(err)) throw err;

    if (statusCode === 401 && !publicAuth) {
        redirectForAuthenticationRequired();
        throw new AuthenticationRequiredError();
    }

    console.error(err);
    if (statusCode === 401) {
        toast.error(handleErrorAsString(err));
        clearLogas();
        router.navigate({ to: `/` });
        return;
    }

    if (statusCode === 403) {
        toast.error(handleErrorAsString(err));
        return;
    }

    if (statusCode <= 400) {
        toast.error(handleErrorAsString(err));
        return;
    }

    toast.error(handleErrorAsString(err));
};
